import React from "react";

/**
 * Renders an SVG component for opening a folder.
 *
 * @param {object} cls - The class name for styling the SVG component
 * @return {JSX.Element} The SVG component for opening a folder
 */
export const FolderOpen = ({ cls }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      className={cls}
    >
      <g clipPath="url(#clip0_2158_62317)">
        <path
          d="M24.4527 11.8246C23.9463 11.1706 23.1694 10.7946 22.3207 10.7946H21.86V8.80759C21.86 6.05059 19.5273 3.80759 16.66 3.80759H11.4018C11.2416 3.80759 11.0794 3.77059 10.9369 3.70259L7.6557 2.12459C7.22514 1.91759 6.74258 1.80859 6.26002 1.80859H4.18002C1.88578 1.80759 0.0200195 3.60159 0.0200195 5.80759V18.8076C0.0200195 21.5646 2.35274 23.8076 5.22002 23.8076H18.2803C20.5954 23.8076 22.5963 22.3756 23.2744 20.2006L24.8677 14.0846C25.1111 13.3026 24.9592 12.4796 24.4527 11.8246ZM2.10002 18.8076V5.80759C2.10002 4.70459 3.0329 3.80759 4.18002 3.80759H6.26002C6.42018 3.80759 6.58242 3.84459 6.7249 3.91259L10.0061 5.49059C10.4367 5.69759 10.9192 5.80659 11.4018 5.80659H16.66C18.3802 5.80659 19.78 7.15259 19.78 8.80659V10.7936H8.97962C7.21162 10.7936 5.6329 11.8726 5.03906 13.5136L2.76146 20.6516C2.34754 20.1426 2.10002 19.5026 2.10002 18.8076ZM22.8626 13.5546L21.2693 19.6696C20.8699 20.9486 19.6687 21.8076 18.2803 21.8076H5.22002C5.0037 21.8076 4.79258 21.7866 4.58874 21.7456L7.0161 14.1366C7.30626 13.3336 8.09666 12.7946 8.98066 12.7946H22.3218C22.5735 12.7946 22.7201 12.9346 22.7846 13.0186C22.8491 13.1026 22.9468 13.2776 22.8626 13.5546Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_2158_62317">
          <rect
            width="24.96"
            height="24"
            fill="white"
            transform="translate(0.0200195 0.807617)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
